import React from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Select, Tooltip } from '@mantine/core';
import {
  ArrowBackUp,
  ArrowForwardUp,
  BucketDroplet,
  Download,
  GridPattern,
  Template
} from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';

const ViewProductPrintImagesCanvasControls = ({
  options,
  formState,
  setFormState,
  onDownloadImage
}) => {
  const currentIndex = options.findIndex(
    (opt) => opt.value === formState.selectedPrintImageValue
  );

  return (
    <AppFlexbox
      style={{
        gap: 12,
        alignContent: 'center',
        justifyContent: 'space-between'
      }}
    >
      <AppFlexbox>
        <Select
          data={options}
          onChange={(v) =>
            setFormState((c) => ({
              ...c,
              selectedPrintImageValue: v
            }))
          }
          value={formState.selectedPrintImageValue}
        />
      </AppFlexbox>

      <AppFlexbox style={{ alignItems: 'center', gap: 5 }}>
        {options.length > 1 && (
          <>
            <AppText style={{ fontSize: 14, color: '#666', marginRight: 5 }}>
              ({currentIndex + 1}/{options.length})
            </AppText>
            <AppFlexbox style={{ alignItems: 'center', gap: 5 }}>
              <Button.Group
                style={{ border: 'solid 1px #dee2e6', borderRadius: 4 }}
              >
                <Tooltip label="Back" withArrow>
                  <Button
                    color="dark"
                    onClick={() => {
                      if (currentIndex > 0) {
                        setFormState((c) => ({
                          ...c,
                          selectedPrintImageValue:
                            options[currentIndex - 1].value
                        }));
                      }
                      else {
                        setFormState((c) => ({
                          ...c,
                          selectedPrintImageValue:
                            options[options.length - 1].value
                        }));
                      }
                    }}
                    size="compact-md"
                    variant="subtle"
                  >
                    <ArrowBackUp size={22} />
                  </Button>
                </Tooltip>

                <Divider orientation="vertical" />

                <Tooltip label="Next" withArrow>
                  <Button
                    color="dark"
                    onClick={() => {
                      if (currentIndex < options.length - 1) {
                        setFormState((c) => ({
                          ...c,
                          selectedPrintImageValue:
                            options[currentIndex + 1].value
                        }));
                      }
                      else {
                        setFormState((c) => ({
                          ...c,
                          selectedPrintImageValue: options[0].value
                        }));
                      }
                    }}
                    size="compact-md"
                    variant="subtle"
                  >
                    <ArrowForwardUp size={22} />
                  </Button>
                </Tooltip>
              </Button.Group>
            </AppFlexbox>
          </>
        )}

        <AppFlexbox style={{ alignItems: 'center', gap: 5 }}>
          <Button.Group
            style={{ border: 'solid 1px #dee2e6', borderRadius: 4 }}
          >
            <Tooltip label="Show design canvas" withArrow>
              <Button
                color="dark"
                onClick={() => {
                  setFormState({
                    ...formState,
                    showOriginalCanvasSize: !formState.showOriginalCanvasSize
                  });
                }}
                size="compact-md"
                variant={formState.showOriginalCanvasSize ? 'filled' : 'subtle'}
              >
                <Template size={22} />
              </Button>
            </Tooltip>

            <Divider orientation="vertical" />

            <Tooltip label="Show gridlines" withArrow>
              <Button
                color="dark"
                onClick={() => {
                  setFormState({
                    ...formState,
                    showGridlines: !formState.showGridlines
                  });
                }}
                size="compact-md"
                variant={formState.showGridlines ? 'filled' : 'subtle'}
              >
                <GridPattern size={22} />
              </Button>
            </Tooltip>
          </Button.Group>

          <Button.Group
            style={{ border: 'solid 1px #dee2e6', borderRadius: 4 }}
          >
            <Tooltip label="Toggle dark background" withArrow>
              <Button
                color="dark"
                onClick={() => {
                  setFormState({
                    ...formState,
                    showBackgroundFill: !formState.showBackgroundFill
                  });
                }}
                size="compact-md"
                variant={formState.showBackgroundFill ? 'filled' : 'subtle'}
              >
                <BucketDroplet size={22} />
              </Button>
            </Tooltip>
          </Button.Group>

          {onDownloadImage && (
            <Button.Group
              style={{ border: 'solid 1px #dee2e6', borderRadius: 4 }}
            >
              <Tooltip label="Download image" withArrow>
                <Button
                  color="dark"
                  onClick={onDownloadImage}
                  size="compact-md"
                  variant="subtle"
                >
                  <Download size={22} />
                </Button>
              </Tooltip>
            </Button.Group>
          )}
        </AppFlexbox>
      </AppFlexbox>
    </AppFlexbox>
  );
};

ViewProductPrintImagesCanvasControls.propTypes = {
  formState: PropTypes.object,
  onDownloadImage: PropTypes.func,
  options: PropTypes.array,
  setFormState: PropTypes.func
};

export default ViewProductPrintImagesCanvasControls;
